 import { 
  statusScientificDayStart,
  statusScientificDaySuccess,
  statusScientificDayFailure 
} from "./scientificDaySlice";

import { get, post, put, remove } from "../../requestMethods"
import { Dispatch } from "react";

export const getScientificDaysApi = () => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusScientificDayStart())
    let response = await get(`scientificday`)
    const resData = response.data.success
    if(resData) {
      dispatch(statusScientificDaySuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusScientificDayFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusScientificDayFailure(errData))
      return [errData]
    }
  }
}

export const AddScientificDayApi = (data: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusScientificDayStart())
    let response = await post(`scientificday`, data);
    const resData = response.data.success
    if(resData) {
      dispatch(statusScientificDaySuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusScientificDayFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusScientificDayFailure(errData))
      return [errData]
    }
  }
}

export const EditScientificDayApi = (scientificdayId: string, data: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusScientificDayStart())
    let response = await put(`scientificday/${scientificdayId}`, data);
    const resData = response.data.success
    if(resData) {
      dispatch(statusScientificDaySuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusScientificDayFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusScientificDayFailure(errData))
      return [errData]
    }
  }
}

export const DeleteScientificDayApi = (scientificdayId: string) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusScientificDayStart())
    let response = await remove(`scientificday/${scientificdayId}`);
    const resData = response.data.success
    if(resData) {
      dispatch(statusScientificDaySuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusScientificDayFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusScientificDayFailure(errData))
      return [errData]
    }
  }
}

export const AddScientificDayPhotoApi = (scientificdayId: string = "", scientificday: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusScientificDayStart())
    const response = await post(`scientificday/${scientificdayId}`, scientificday)
    const dataRes  = await response.data.success
    if(dataRes) {
      dispatch(statusScientificDaySuccess(dataRes))
      return true;
    }
  } catch (err: any) {
    const errData = err.response.data
    const formErrors = errData.formErrors ? errData.formErrors : [errData];
    if(err.response && err.response.status === 300) {
      dispatch(statusScientificDayFailure(formErrors))      
      return formErrors
    } else {
      dispatch(statusScientificDayFailure(errData.err))      
      return [errData.err]
    }
  }
}

export const DeleteScientificDayPhotoApi = (id: any, img: any = "") => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusScientificDayStart());
    const response = await remove(`scientificday/${id}/${img}`);
    const dataRes = response.data.success
    if(dataRes) {
      dispatch(statusScientificDaySuccess(dataRes))
      return true;
    }
  } catch(err: any) {
    const errData = err.response.data
    const formErrors = errData.formErrors ? errData.formErrors : [errData];
    if(err.response && err.response.status === 300) {
      dispatch(statusScientificDayFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusScientificDayFailure(errData.err))
      return errData.err
    }
  }
}

export const clearScientificDayApi = async (dispatch: Dispatch<any>) => {
  dispatch(statusScientificDaySuccess([]))
}
